module.exports = __webpack_public_path__ + "static/media/rebirth_sample_2.25574d21.jpg";